import React from 'react';
import c from 'classnames';
import StandardDropdown, {
  Props as StandardDropdownProps,
} from '../StandardDropdown';
import s from './FormDropdown.scss';

export type Props = Omit<
  StandardDropdownProps,
  | 'role'
  | 'toggleClassName'
  | 'openClassName'
  | 'placeholderClassName'
  | 'usePortal'
  | 'menuScrollable'
>;

const FormDropdown: React.FC<Props> = ({
  className,
  menuClassName,
  ...props
}) => {
  return (
    <StandardDropdown
      role="listbox"
      className={c(s['dropdown'], className)}
      menuClassName={c(s['dropdown-menu'], menuClassName)}
      toggleClassName={s['dropdown-toggle']}
      openClassName={s['dropdown-selected']}
      placeholderClassName={s['dropdown-placeholder']}
      usePortal
      menuScrollable
      {...props}
    />
  );
};
FormDropdown.displayName = 'FormDropdown';

export default FormDropdown;
